const styles = {
  responsiveWrapper: {
    width: "100%",
    maxWidth: "100vw",
    overflow: "hidden",
    boxSizing: "border-box",
    background: "#F0F4FA",
    minHeight: "100vh",
    padding: { xs: "0.75rem", md: "1.25rem" },
    "& *": {
      boxSizing: "border-box",
      maxWidth: "100%",
    },
    "& > *": {
      width: "100%",
      minWidth: 0,
    },
  },

  mainContainer: {
    flex: { xs: 1, md: 6 },
    padding: { xs: "0", md: "0" },
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
  },

  main: {
    flex: { xs: 1, md: 4 },
    padding: { xs: "0.25rem", md: "0.5rem" },
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },

  rightAside: {
    flex: { xs: 1, md: 2 },
    paddingRight: { xs: "0.5rem", md: "1rem" },
    display: "flex",
    flexDirection: "column",
    gap: { xs: "1rem", md: "1.25rem" },
    width: "100%",
    maxWidth: "100%",
  },

  cardContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "0.75rem", md: "1rem" },
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    "& > *": {
      flex: { xs: "1 1 100%", md: "1 1 auto" },
      minWidth: { xs: "100%", md: "280px" },
      maxWidth: "100%",
    },
  },

  card: {
    background: "#FFFFFF",
    borderRadius: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    overflow: "hidden",
    width: "100%",
  },

  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px 12px",
    borderBottom: "1px solid #F0F4FA",
  },

  cardTitle: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#1A2B4A",
    letterSpacing: "-0.2px",
  },

  cardSubCount: {
    fontSize: "12px",
    color: "#8A9BB0",
    fontWeight: 400,
    marginTop: "2px",
  },

  cardContainerMobile: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    width: "100%",
    maxWidth: "100%",
  },

  appointment: {
    padding: { xs: "0 0.5rem 0.5rem", md: "0 1rem 0.5rem" },
    width: "100%",
    maxWidth: "100%",
  },

  // Timeline styles for appointment history
  timelineContainer: {
    padding: "12px 16px",
    overflowY: "auto",
    maxHeight: "420px",
  },

  timelineItem: {
    display: "flex",
    gap: "14px",
    paddingBottom: "18px",
    position: "relative",
  },

  timelineYear: {
    minWidth: "48px",
    fontSize: "12px",
    fontWeight: 700,
    color: "#5C7A9B",
    paddingTop: "2px",
    textAlign: "right",
    flexShrink: 0,
  },

  timelineDotWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: 0,
  },

  timelineDotGreen: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: "#22C55E",
    border: "2px solid #fff",
    boxShadow: "0 0 0 2px #22C55E40",
    flexShrink: 0,
    marginTop: "4px",
  },

  timelineDotYellow: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: "#F59E0B",
    border: "2px solid #fff",
    boxShadow: "0 0 0 2px #F59E0B40",
    flexShrink: 0,
    marginTop: "4px",
  },

  timelineDotRed: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: "#EF4444",
    border: "2px solid #fff",
    boxShadow: "0 0 0 2px #EF444440",
    flexShrink: 0,
    marginTop: "4px",
  },

  timelineLine: {
    flex: 1,
    width: "2px",
    background: "#E8EDF4",
    marginTop: "4px",
  },

  timelineContent: {
    flex: 1,
    paddingBottom: "4px",
  },

  timelineTitle: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#1A2B4A",
    marginBottom: "3px",
  },

  timelineLocation: {
    fontSize: "11px",
    color: "#8A9BB0",
    marginBottom: "2px",
    lineHeight: 1.4,
  },

  timelineDate: {
    fontSize: "11px",
    color: "#A0AEC0",
    marginBottom: "2px",
  },

  timelineReason: {
    fontSize: "10px",
    color: "#B0BFCF",
    fontStyle: "italic",
  },

  timelineBadgeMain: {
    display: "inline-block",
    fontSize: "10px",
    fontWeight: 600,
    color: "#2563EB",
    background: "#EFF6FF",
    borderRadius: "20px",
    padding: "1px 8px",
    marginBottom: "3px",
  },

  timelineBadgeDual: {
    display: "inline-block",
    fontSize: "10px",
    fontWeight: 600,
    color: "#D97706",
    background: "#FFFBEB",
    borderRadius: "20px",
    padding: "1px 8px",
    marginBottom: "3px",
  },

  // Examination icon list styles
  examList: {
    padding: "12px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  examItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 12px",
    borderRadius: "10px",
    background: "#F8FAFD",
    transition: "background 0.15s",
  },

  examIconWrap: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: "16px",
  },

  examLabel: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#1A2B4A",
    flex: 1,
  },

  examDate: {
    fontSize: "11px",
    color: "#8A9BB0",
  },

  // Table head cells
  tableHeadCells: {
    padding: { xs: ".3rem .5rem", md: ".5rem 1rem" },
    color: "#3D5A80",
    fontWeight: 700,
    background: "#EDF2FB",
    fontSize: { xs: "11px", md: "13px" },
    borderBottom: "none",
    letterSpacing: "0.2px",
  },

  appointmentTableHeadCell: {
    padding: { xs: ".3rem .5rem", md: ".5rem 1rem" },
    color: "#3D5A80",
    fontWeight: 700,
    background: "#EDF2FB",
    fontSize: { xs: "11px", md: "13px" },
  },

  awardsTableHeadCell: {
    padding: { xs: ".3rem .5rem", md: ".5rem 1rem" },
    color: "#5B3F8A",
    fontWeight: 700,
    background: "#F0EBFF",
    fontSize: { xs: "11px", md: "13px" },
  },

  gohonzonTableHeadCell: {
    padding: { xs: "2px", md: "4px" },
    color: "#3D5A80",
    fontWeight: 700,
    background: "#EDF2FB",
    fontSize: { xs: "10px", md: "13px" },
  },

  tableRowCell: {
    borderBottom: "1px solid #EDF2FB",
    padding: { xs: ".3rem .5rem", md: ".5rem 1rem" },
    fontSize: { xs: "11px", md: "13px" },
    wordBreak: "break-word",
    color: "#374151",
  },

  status: {
    backgroundColor: "#ECFDF5",
    border: "1px solid #6EE7B7",
    borderRadius: 20,
    padding: { xs: "2px 8px", md: "2px 12px" },
    fontSize: { xs: "10px", md: "11px" },
    fontWeight: 600,
    color: "#059669",
    whiteSpace: "nowrap",
  },

  // Attendance section
  attandence: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "0.75rem", md: "1rem" },
    padding: { xs: "0.5rem", md: "0.75rem 1rem" },
    flex: 1,
    width: "100%",
    maxWidth: "100%",
  },

  attandenceTable: {
    flex: 1,
    width: "100%",
    minWidth: 0,
    overflowX: "auto",
    background: "#FFFFFF",
    borderRadius: "12px",
    padding: "12px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
  },

  attendanceTableHeading: {
    paddingBottom: { xs: "0.3rem", md: "0.5rem" },
    fontSize: { xs: "13px", md: "14px" },
    fontWeight: 700,
    color: "#1A2B4A",
  },

  // Trends/stats cards
  trendCard: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 14px",
    borderRadius: "10px",
    marginBottom: "8px",
  },

  trendCardBlue: {
    background: "#FFF8E8",
    borderRadius: "10px",
    marginBottom: "8px",
  },

  trendCardGreen: {
    background: "#E8FFF3",
    borderRadius: "10px",
    marginBottom: "8px",
  },

  trendCardRed: {
    background: "#FFF0F0",
    borderRadius: "10px",
    marginBottom: "8px",
  },

  trendCardPurple: {
    background: "#F3EEFF",
    borderRadius: "10px",
    marginBottom: "8px",
  },

  // Meetings attended header
  meetingsHeader: {
    background: "#FFFFFF",
    borderRadius: "16px",
    padding: "16px 20px 12px",
    marginBottom: "1rem",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  },

  meetingsTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#1A2B4A",
    marginBottom: "4px",
  },

  // Meeting table panel
  meetingPanel: {
    background: "#FFFFFF",
    borderRadius: "14px",
    boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
    overflow: "hidden",
    flex: 1,
    minWidth: 0,
  },

  meetingPanelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px 10px",
    borderBottom: "1px solid #F0F4FA",
  },

  meetingPanelTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#1A2B4A",
  },

  listContainer: {
    padding: { xs: "0 0.5rem", md: "0 1rem" },
    width: "100%",
  },

  item: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    background: "#FFF5F5",
    margin: { xs: "6px 0", md: "8px 0" },
    padding: { xs: "6px 10px", md: "8px 12px" },
    borderRadius: "8px",
    gap: "4px",
    wordBreak: "break-word",
    borderLeft: "3px solid #FCA5A5",
  },

  remark: {
    display: "flex",
    flexGrow: 1,
    background: "#F0F4FA",
    margin: { xs: "0 4px 6px 4px", md: "0 8px 8px 8px" },
    padding: { xs: "6px 10px", md: "8px 12px" },
    borderRadius: "10px",
    boxShadow: "inset 0 1px 4px rgba(0,0,0,0.06)",
    maxWidth: "100%",
    boxSizing: "border-box",
    wordBreak: "break-word",
  },

  modal: {
    maxHeight: { xs: "98%", md: "95%" },
    minWidth: { xs: "95%", md: "40%" },
    maxWidth: "98%",
    overflowY: "auto",
    margin: { xs: "0.5rem", md: "auto" },
    borderRadius: "16px",
  },

  inputStyle: {
    height: { xs: 150, md: 191 },
    minWidth: { xs: "100%", md: 330 },
    maxWidth: { xs: "100%", md: 400 },
    borderRadius: "10px",
    width: "100%",
  },

  lastContainer: {
    padding: { xs: "0 0.5rem", md: "0 1rem" },
    width: "100%",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "0.75rem", md: "1rem" },
    flex: 1,
  },

  remarksStyle: {
    color: "#374151",
    fontSize: { xs: "12px", md: "13px" },
    maxWidth: "100%",
    height: "25px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
  },

  hoverStyle: {
    padding: { xs: "3px 6px", md: "4px 8px" },
    position: "absolute",
    left: { xs: "50%", md: "0px" },
    top: "70%",
    transform: { xs: "translate(-50%, 0)", md: "translateX(-50%)" },
    color: "white",
    fontSize: { xs: "10px", md: "12px" },
    borderRadius: "6px",
    zIndex: 2,
    backgroundColor: "#1A2B4A",
    maxWidth: { xs: "150px", md: "250px" },
    wordWrap: "break-word",
  },

  flagSvgStyle: {
    cursor: "pointer",
    position: "relative",
    display: "inline-block",
    width: { xs: "18px", md: "24px" },
    height: { xs: "18px", md: "24px" },
  },

  // Section wrapper for grouped cards
  sectionWrapper: {
    background: "#FFFFFF",
    borderRadius: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    overflow: "hidden",
    width: "100%",
    marginBottom: "0",
  },

  sectionHeader: {
    padding: "14px 20px",
    background: "#FFFFFF",
    borderBottom: "1px solid #EDF2FB",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  sectionTitle: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#1A2B4A",
  },

  sectionSubtitle: {
    fontSize: "11px",
    color: "#8A9BB0",
    marginTop: "2px",
  },

  // Dot badge for status
  dotBadge: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "6px",
  },
};

export default styles;
